import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidePanelService } from '../../shared/services/side-pannel/side-pannel.service';
import { HomeService } from '../../shared/services/home.service';
import { SupersetDashboardService } from 'src/app/superset-dashboard/service/superset-dashboard.service';
import { VisibilityService } from 'src/app/shared/services/visibility.service';

@Component({
  selector: 'app-study-superset',
  templateUrl: './study-superset.component.html',
  styleUrls: ['./study-superset.component.scss']
})
export class StudySupersetComponent implements OnInit, OnDestroy {
  studyName: string = '';

  currentDashboardId: string = '';
  currentDashboardTitle: string = '';
  private routeSub: Subscription;
  
  constructor(
    public supersetDashboardService:SupersetDashboardService,
    private route:ActivatedRoute,
    private router:Router,
    public homeService:HomeService,
    private visibilityService: VisibilityService,
  ) { }

  ngOnInit(): void {
    this.homeService.isOpen = false;
    this.setupRouteSubscription();
  }


  


  

  

  private setupRouteSubscription(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const dashboardId = params.get('id');
      const dashboardTitle = params.get('name');
      this.currentDashboardId = dashboardId;
      this.currentDashboardTitle = dashboardTitle;
      this.getStudyDetails(dashboardId);
    });
  }


  getStudyDetails(study_id: string | null):void{
    this.visibilityService.getStudyDetails(study_id).subscribe((res:any) => {
      if(res && res.status && res.studyName){
        this.studyName = res.studyName;
      }
    });
  }

  

  ngOnDestroy(): void {
    this.homeService.isOpen = true;
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  navigateToPerformanceTracker(){
    this.router.navigate(['/home/performance-tracker',this.currentDashboardId]);
  }

  navigateToSuperSetMenuDash(){
    this.router.navigate(['/home/dash-suite',this.currentDashboardId]);
  }
}
